"use client";

const DICAS = [
  {
    ico: "🔌",
    titulo: "Use cabo de rede",
    desc: "Conecte o computador diretamente no roteador via cabo ethernet (não via Wi-Fi).",
  },
  {
    ico: "🗂️",
    titulo: "Feche tudo antes de testar",
    desc: "Feche todos os programas e abas que usam internet antes de testar.",
  },
  {
    ico: "🔁",
    titulo: "Teste 3 vezes e tire a média",
    desc: "Faça o teste 3 vezes e tire a média — um único teste pode ter variação.",
  },
];

export function SpeedTestGuide() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* Título + aviso */}
      <div>
        <h3 style={{ fontSize: 16, fontWeight: 800, color: "var(--text)", marginBottom: 6 }}>
          Como fazer o teste de velocidade corretamente
        </h3>
        <p style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.6 }}>
          Abaixo explicamos os passos para garantir um resultado preciso.
        </p>
      </div>

      {/* Alerta Wi-Fi */}
      <div style={{
        display: "flex", alignItems: "center", gap: 12,
        background: "rgba(239,68,68,.07)",
        border: "1px solid rgba(239,68,68,.2)",
        borderRadius: 12, padding: "12px 16px",
      }}>
        <span style={{ fontSize: 20, flexShrink: 0 }}>⚠️</span>
        <p style={{ fontSize: 13, color: "#fca5a5", fontWeight: 600, lineHeight: 1.5 }}>
          Nunca via Wi-Fi — pode haver variações significativas no resultado.
        </p>
      </div>

      {/* Dicas */}
      {DICAS.map((d, i) => (
        <div
          key={i}
          style={{
            display: "flex", gap: 14, alignItems: "flex-start",
            background: "var(--surface2)",
            border: "1px solid var(--border)",
            borderRadius: 12, padding: "14px 16px",
          }}
        >
          <div style={{
            width: 40, height: 40, borderRadius: 10, flexShrink: 0,
            background: "rgba(37,99,235,.15)",
            border: "1px solid rgba(37,99,235,.2)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 20,
          }}
            role="img"
            aria-hidden="true"
          >
            {d.ico}
          </div>
          <div>
            <p style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>{d.titulo}</p>
            <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 4, lineHeight: 1.6 }}>{d.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
